/* eslint-disable jsx-a11y/accessible-emoji */

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card } from "antd";
import sal from "sal.js";
import "sal.js/dist/sal.css";

export default function Finance({ setRoute }) {
  const [loading, setLoading] = useState(true);
  const cardHalfStyle = {
    boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
    width: "42%",
    display: "inline-block",
    margin: "1.6rem",
  };
  const cardWholeStyle = {
    boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
    width: "87.5%",
    display: "inline-block",
    marginTop: "1.6rem",
    marginBottom: "1.6rem",
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 400);
    sal({ threshold: 0 });
  }, []);

  return (
    <div style={{ padding: "2rem 6rem" }}>
      <h1 data-sal="slide-up" data-sal-duration="800">
        Financial Overview
      </h1>
      <div>
        <Card data-sal="slide-up" data-sal-delay="100" data-sal-duration="800" style={cardHalfStyle}>
          <h2>Your Community Dues</h2>
          <h1 style={{ fontSize: "72px" }}>$0</h1>
          <p style={{ opacity: "0.50", marginTop: "-35px", marginBottom: "20px", fontSize: "15px" }}>
            Next payment due 14 February 2022
          </p>
          <button
            style={{
              backgroundColor: "#6c757d",
              width: "100%",
              fontSize: "16px",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              padding: "1rem",
              cursor: "not-allowed",
            }}
          >
            Pay Dues
          </button>
        </Card>
        <Card data-sal="slide-up" data-sal-delay="200" data-sal-duration="800" style={cardHalfStyle}>
          <h2>Your Community Fund</h2>
          <h1 style={{ fontSize: "72px" }}>$2500</h1>
          <p style={{ opacity: "0.50", marginTop: "-35px", marginBottom: "20px", fontSize: "15px" }}>
            Stored on the blockchain as 2500 DAI
          </p>
          <Link
            onClick={() => {
              console.log("aa");
              setRoute("/proposals");
            }}
            to="/proposals"
          >
            <button
              style={{
                backgroundColor: "#2F43F5",
                width: "100%",
                fontSize: "16px",
                border: "none",
                borderRadius: "6px",
                color: "#fff",
                padding: "1rem",
                cursor: "pointer",
              }}
            >
              Vote on Proposals
            </button>
          </Link>
        </Card>
        <Card data-sal="slide-up" data-sal-delay="300" data-sal-duration="800" style={cardWholeStyle}>
          <h1>The Community Ledger</h1>
          {/* table */}
          <div style={{ width: "100%", margin: "1.5rem 0" }}>
            {/* row */}
            <div style={{ width: "100%", padding: "0.75rem 0" }}>
              {/* col */}
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4>Date</h4>
              </div>
              <div style={{ width: "60%", display: "inline-block" }}>
                <h4>Name</h4>
              </div>
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4>Amount</h4>
              </div>
            </div>
            <div
              data-sal="slide-up"
              data-sal-delay="400"
              data-sal-duration="800"
              style={{ width: "100%", padding: "0.75rem 0" }}
            >
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4>02/14/2021</h4>
              </div>
              <div style={{ width: "60%", display: "inline-block" }}>
                <h4>Initial Palo Alto Funding</h4>
              </div>
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4 style={{ color: "green" }}>+2500 DAI (~2500 USD)</h4>
              </div>
            </div>
            <div
              data-sal="slide-up"
              data-sal-delay="500"
              data-sal-duration="800"
              style={{ width: "100%", padding: "0.75rem 0" }}
            >
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4>02/14/2021</h4>
              </div>
              <div style={{ width: "60%", display: "inline-block" }}>
                <h4>BlockFund Protocol Fee</h4>
              </div>
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4 style={{ color: "red" }}>-100 DAI (~100 USD)</h4>
              </div>
            </div>
            <div
              data-sal="slide-up"
              data-sal-delay="600"
              data-sal-duration="800"
              style={{ width: "100%", padding: "0.75rem 0" }}
            >
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4>02/14/2021</h4>
              </div>
              <div style={{ width: "60%", display: "inline-block" }}>
                <h4>Scott Moses Sunarto Membership Payment</h4>
              </div>
              <div style={{ width: "20%", display: "inline-block" }}>
                <h4 style={{ color: "green" }}>+100 DAI (~100 USD)</h4>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
